module.exports = __webpack_public_path__ + "static/media/mcd.1b876bad.svg";